import StopCard from './StopCard';
import useTripStore from '../../context/TripStore';

const Timeline = () => {
  const { itinerary, places } = useTripStore();
  const activePlan = itinerary.activePlan === 'a' ? itinerary.planA : itinerary.planB;

  if (!activePlan || !activePlan.stops || activePlan.stops.length === 0) {
    return (
      <div className="border border-dashed border-gray-300 p-8 text-center">
        <p className="text-xs font-light text-gray-400">No itinerary generated yet.</p>
      </div>
    );
  }

  // Create a map of locked times for quick lookup
  const lockedTimesMap = {};
  places.forEach(place => {
    if (place.lockedTime) {
      lockedTimesMap[place.name] = place.lockedTime;
    }
  });

  return (
    <div className="space-y-3">
      {activePlan.summary && (
        <div className="border border-gray-200 p-3 mb-3">
          <p className="text-xs font-light text-gray-600">{activePlan.summary}</p>
        </div>
      )}

      <div className="space-y-3">
        {activePlan.stops.map((stop, index) => {
          const isLocked = lockedTimesMap[stop.name] !== undefined;
          return (
            <div key={index} className="flex gap-3">
              <div className="flex flex-col items-center">
                <div className="w-6 h-6 border border-gray-400 text-gray-900 flex items-center justify-center text-xs font-light">
                  {index + 1}
                </div>
                {index < activePlan.stops.length - 1 && (
                  <div className="w-px h-full bg-gray-300 my-1"></div>
                )}
              </div>
              <div className="flex-1">
                <StopCard stop={stop} isLocked={isLocked} />
              </div>
            </div>
          );
        })}
      </div>

      {activePlan.cuts && activePlan.cuts.length > 0 && (
        <div className="mt-6 border border-gray-200 p-3">
          <h3 className="text-xs font-light uppercase tracking-wide text-gray-600 mb-2">Items that didn't fit:</h3>
          <ul className="space-y-1">
            {activePlan.cuts.map((cut, index) => (
              <li key={index} className="text-xs font-light text-gray-500">
                <span className="line-through">{cut.name}</span> - {cut.reason}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Timeline;

